import myAxios from './axiositeachWrapper';
import Config from '../_config/config';

const BASE_URL = `${Config.nodeSiteUrl}v1/academic/course-year-properties`;

class CourseYearPropertiesService {
  /**
   * List course year properties with filters
   */
  list(params: {
    startDate?: string;
    endDate?: string;
    programIds?: number[];
    moduleCode?: string;
    limit?: number;
    offset?: number;
  }) {
    const query: string[] = [];
    if (params.startDate) query.push(`startDate=${params.startDate}`);
    if (params.endDate) query.push(`endDate=${params.endDate}`);
    if (params.programIds && params.programIds.length > 0) {
      query.push(`programIds=${params.programIds.join(',')}`);
    }
    if (params.moduleCode) {
      query.push(`moduleCode=${encodeURIComponent(params.moduleCode)}`);
    }
    if (params.limit) query.push(`limit=${params.limit}`);
    if (params.offset) query.push(`offset=${params.offset}`);
    const url = query.length > 0 ? `${BASE_URL}?${query.join('&')}` : BASE_URL;
    return myAxios.get(url);
  }

  /**
   * Update a course year property record
   */
  update(id: number, fields: Record<string, any>) {
    return myAxios.patch(`${BASE_URL}/${id}`, fields);
  }
}

export default new CourseYearPropertiesService();
